import { Popover } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { hexToRgba } from '~/utils'
import Script from 'next/script'
import { MyIcon } from '../ui/MyIcon'
import { CDNImage } from '../ui/CDNImage'

const StyledRightBar = styled.div`
  position: fixed;
  bottom: 40px;
  right: 24px;
  background: #ffffff;
  box-shadow: 0px 8px 24px -8px rgba(15, 15, 15, 0.08);
  border-radius: 16px;
  padding: 8px 12px;
  color: ${props => props.theme.dark4};
  text-align: center;
  z-index: 10;
  .bar-item {
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    cursor: pointer;
    & + .bar-item {
      border-top: 1px solid ${props => hexToRgba(props.theme.dark5, 0.16)};
    }
  }
  .bar-icon {
    position: relative;
    margin-bottom: 6px;
    .bar-dot {
      position: absolute;
      right: 12px;
      top: 4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #ef466f;
    }
    img {
      width: 32px;
    }
  }
  .bar-text {
    font-size: 12px;
    line-height: 20px;
  }
`

const getMeiqia = () => {
  return {
    __html: `
    (function(a, b, c, d, e, j, s) {
      a[d] = a[d] || function() {
          (a[d].a = a[d].a || []).push(arguments)
      };
      j = b.createElement(c),
          s = b.getElementsByTagName(c)[0];
      j.async = true;
      j.charset = 'UTF-8';
      j.src = 'https://static.meiqia.com/widget/loader.js';
      s.parentNode.insertBefore(j, s);
    })(window, document, 'script', '_MEIQIA');
    _MEIQIA('entId', '40d34b649ed60b6b051e858271ce4f66');
    _MEIQIA('manualInit');
    _MEIQIA('withoutBtn');
    _MEIQIA('fallback', 1);
  `,
  }
}

export const RightBar = () => {
  const [hasNum, setHasNum] = useState(false)
  const [hasMallNum, setHasMallNum] = useState(false)

  const openModal = () => {
    window._MEIQIA('showPanel', {
      groupToken: '4d6d29bd0c7691d5a241e4c6f45dbda0',
    })
  }

  const openMallModal = () => {
    window._MEIQIA('showPanel', {
      groupToken: '8d37f6724008cb540fb42afdf32c5f54',
    })
  }

  useEffect(() => {
    window._MEIQIA('getUnreadMsg', (msg: any) => {
      console.log(msg, 'getUnreadMsg')
      if (msg === 'hasBeenRead') {
        setHasNum(false)
        setHasMallNum(false)
      } else if (typeof msg === 'object') {
        if (msg?.[0]?.agent?.group_id === 736764) {
          setHasNum(true)
        }

        if (msg?.[0]?.agent?.group_id === 742926) {
          setHasMallNum(true)
        }
      }
    })
    window._MEIQIA('init')
  }, [])

  return (
    <StyledRightBar>
      <div className="bar-item" onClick={openModal}>
        <span className="bar-icon">
          <MyIcon icon="cooperation" className="text-[32px] text-neutral-500" />
          {hasNum && <span className="bar-dot"></span>}
        </span>
        <span className="bar-text">商务合作</span>
      </div>

      <div className="bar-item" onClick={openMallModal}>
        <span className="bar-icon">
          <MyIcon
            icon="connect-filled"
            className="text-[32px] text-neutral-500"
          />
          {hasMallNum && <span className="bar-dot"></span>}
        </span>
        <span className="bar-text">文创客服</span>
      </div>

      <Popover
        getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement}
        content={
          <div
            className="flex"
            style={{
              margin: '-6px -10px',
            }}
          >
            <div
              style={{
                width: 150,
                textAlign: 'center',
              }}
            >
              <CDNImage
                style={{ width: 150 }}
                src="/images/contact.jpeg"
                alt="用户小助手"
              />
              <div style={{ color: '#777E90' }}>用户小助手</div>
            </div>
            <div
              style={{
                width: 150,
                textAlign: 'center',
              }}
            >
              <CDNImage
                style={{ width: 150 }}
                src="/images/contact-creator-v2.png"
                alt="创作者小助手"
              />
              <div style={{ color: '#777E90' }}>创作者小助手</div>
            </div>
            <div
              style={{
                width: 150,
                textAlign: 'center',
              }}
            >
              <CDNImage
                style={{ width: 150 }}
                src="/images/contact-mall.jpeg"
                alt="文创小助手"
              />
              <div style={{ color: '#777E90' }}>文创小助手</div>
            </div>
          </div>
        }
        placement="left"
      >
        <div className="bar-item">
          <span className="bar-icon">
            <MyIcon icon="qrcode" className="text-[32px] text-neutral-500" />
          </span>
          <span className="bar-text">小助手</span>
        </div>
      </Popover>
      <Script
        id="meiqia"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={getMeiqia()}
      />
    </StyledRightBar>
  )
}
